import { ACCOUNTSDESTINATIONS_GET_ACCOUNTSDESTINATIONS } from "./accounts-destinations-types";

export const getAccountsDestinations = (accountDestination: any[]) => (dispatch: any) =>
  dispatch({ type: ACCOUNTSDESTINATIONS_GET_ACCOUNTSDESTINATIONS, payload: accountDestination });
